import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  const logoUrl = 'https://cdn.magicpatterns.com/uploads/c9BJ1X3xKAxokqvkAeBFyG/equipme-coaching-white-logo-scaled-768x126.png';
  return <footer className="bg-brand-charcoal text-brand-off-white pt-20 pb-10 relative" data-id="element-124">
      {/* Gradient Line at Top */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-brand-teal via-brand-magenta to-brand-orange" data-id="element-125"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-126">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-127">
          {/* Brand Col */}
          <div className="lg:col-span-1" data-id="element-128">
            <img src={logoUrl} alt="EquipMe Coaching & Consulting" className="h-[42px] mb-6 opacity-90" data-id="element-129" />
            <p className="text-[15px] text-white/70 leading-relaxed mb-6 font-normal" data-id="element-130">
              External Ombuds, Culture Transformation & Leadership Consulting.
            </p>
            <p className="text-[15px] text-white/70 leading-relaxed font-medium" data-id="element-131">
              Independent, neutral and confidential support for Australian
              organisations.
            </p>
            <div className="mt-6 pt-6 border-t border-white/10" data-id="element-132">
              <p className="text-xs text-white/50 font-normal" data-id="element-133">
                EquipMe Coaching & Consulting Pty Ltd
                <br data-id="element-134" />
                ABN 12 345 678 901
                <br data-id="element-135" />
                Certified Organisational Ombuds
              </p>
            </div>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-136">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-137">Navigation</h4>
            <ul className="space-y-3 text-[15px] text-white/70 font-normal" data-id="element-138">
              <li data-id="element-139">
                <a href="#" className="hover:text-brand-lime transition-colors" data-id="element-140">
                  Home
                </a>
              </li>
              <li data-id="element-141">
                <a href="#about" className="hover:text-brand-lime transition-colors" data-id="element-142">
                  About
                </a>
              </li>
              <li data-id="element-143">
                <a href="#resources" className="hover:text-brand-lime transition-colors" data-id="element-144">
                  Resources
                </a>
              </li>
              <li data-id="element-145">
                <a href="#contact" className="hover:text-brand-lime transition-colors" data-id="element-146">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-147">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-148">Services</h4>
            <ul className="space-y-3 text-[15px] text-white/70 font-normal" data-id="element-149">
              <li data-id="element-150">
                <a href="#ombuds" className="hover:text-brand-lime transition-colors" data-id="element-151">
                  External Ombuds & Conflict Resolution
                </a>
              </li>
              <li data-id="element-152">
                <a href="#culture" className="hover:text-brand-lime transition-colors" data-id="element-153">
                  Culture, DEI & Workplace Transformation
                </a>
              </li>
              <li data-id="element-154">
                <a href="#leadership" className="hover:text-brand-lime transition-colors" data-id="element-155">
                  Leadership Coaching & Development
                </a>
              </li>
              <li data-id="element-156">
                <a href="#advisory" className="hover:text-brand-lime transition-colors" data-id="element-157">
                  Workplace Advisory
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div data-id="element-158">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-159">Contact</h4>
            <ul className="space-y-4 text-[15px] text-white/70 font-normal" data-id="element-160">
              <li className="flex items-start gap-3" data-id="element-161">
                <Phone size={16} className="shrink-0 mt-1 text-brand-teal" data-id="element-162" />
                <div data-id="element-163">
                  <a href="tel:+61432357868" className="block hover:text-brand-lime transition-colors" data-id="element-164">
                    +61 432 357 868
                  </a>
                  <a href="tel:+61861894910" className="block hover:text-brand-lime transition-colors" data-id="element-165">
                    +61 8 6189 4910 (Landline)
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-166">
                <Mail size={16} className="shrink-0 mt-1 text-brand-teal" data-id="element-167" />
                <a href="mailto:info@equipme-coachconsult.com" className="hover:text-brand-lime transition-colors break-all" data-id="element-168">
                  info@equipme-coachconsult.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-169">
                <MapPin size={16} className="shrink-0 mt-1 text-brand-teal" data-id="element-170" />
                <span data-id="element-171">
                  Level 28, 140 St Georges Terrace,
                  <br data-id="element-172" />
                  Perth, Australia
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50 font-normal" data-id="element-173">
          <p data-id="element-174">
            &copy; {new Date().getFullYear()} EquipMe Coaching & Consulting Pty
            Ltd. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-175">
            <a href="#privacy" className="hover:text-brand-lime transition-colors" data-id="element-176">
              Privacy Policy
            </a>
            <a href="#terms" className="hover:text-brand-lime transition-colors" data-id="element-177">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}